export const LOGO_SEMENTE = "/logos/logo_semente.png";
export const LOGO_RAIZES = "/logos/logo_raizes_dark.png";
export const LOGO_RAIZES_DARK = "/logos/logo_raizes_dark.png";
export const LOGO_RAIZES_WHITE = "/logos/logo_raizes_white.png";
